import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { CustomCollapseCard, Text, CustomSmallCard, useText } from '@src/components';

import { moneyFormat } from '@src/utils/utils';

import { getTotalAutoLoadingParams } from '@src/store/slice/autoUploadInstructionsSlice';

import '@src/styles/autoUploadInstruction/orderSummaryInformation.scss';

const OrderSummaryInformation = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { totalAutoLoading } = useSelector((state) => state?.autoUploadInstructions);

  const numberOfCards = useText('numberOfCards');
  const totalBalanceLoad = useText('totalBalanceLoad');
  const totalAmountToBePaid = useText('totalAmountToBePaid');

  useEffect(async () => {
    const params = new URLSearchParams(history.location.search);
    let integrationId = params.get('updateId') ?? 0;
    if (!integrationId) {
      integrationId = params.get('instructionId') ?? 0;
    }
    if (integrationId) {
      const body = {
        autoLoadingId: 0,
        integrationId: integrationId,
      };
      await dispatch(getTotalAutoLoadingParams(body));
    } else {
      const body = {
        autoLoadingId: totalAutoLoading?.id,
        integrationId: 0,
      };
      await dispatch(getTotalAutoLoadingParams(body));
    }
  }, [history, dispatch]);

  return (
    <CustomCollapseCard
      cardTitle={<Text t="yourInstructionSummary" />}
      cardTitleAlign="left"
      className="autoUploadInstruction-instruction-order-summary-information"
    >
      <div className="autoUploadInstruction-instruction-summary-container">
        <div className="autoUploadInstruction-instruction-summary-container-information">
          <div className="autoUploadInstruction-instruction-summary-container-information-area">
            <span className="autoUploadInstruction-instruction-summary-container-information-area-title">
              <Text t="orderType" />:
            </span>
            <span className="autoUploadInstruction-instruction-summary-container-information-area-description">
              {totalAutoLoading.orderProcessType === 2 ? <Text t="classic" /> : 'Excel'}
            </span>
          </div>

          <div className="autoUploadInstruction-instruction-summary-container-information-area">
            <span className="autoUploadInstruction-instruction-summary-container-information-area-title">
              <Text t="autoActivationDate" />:
            </span>
            <span className="autoUploadInstruction-instruction-summary-container-information-area-description">
              <Text t="ofEachMonth" /> {totalAutoLoading.startDay}
              <Text t="day2" />
            </span>
          </div>

          <div className="autoUploadInstruction-instruction-summary-container-information-area">
            <span className="autoUploadInstruction-instruction-summary-container-information-area-title">
              <Text t="approvalRequest" />
            </span>
            <span className="autoUploadInstruction-instruction-summary-container-information-area-description">
              {totalAutoLoading.confirmEveryMonth === 0
                ? <Text t="iDonTWantToApproveEveryMonth" />
                : <Text t="iWantToApproveEveryMonth" />}
            </span>
          </div>
        </div>
        <div className="autoUploadInstruction-instruction-summary-container-price-area">
          <CustomSmallCard title={numberOfCards + ':'} description={`${totalAutoLoading?.totalCount}`} />
          <CustomSmallCard
            title={totalBalanceLoad + ':'}
            description={moneyFormat(totalAutoLoading?.totalPrice, true)}
          />
          <CustomSmallCard
            title={totalAmountToBePaid + ':'}
            description={moneyFormat(totalAutoLoading?.totalPaymentPrice, true)}
          />
        </div>
      </div>
    </CustomCollapseCard>
  );
};

export default OrderSummaryInformation;
